import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as s } from "tslib";
import { css as i, LitElement as o, html as n } from "lit";
import { property as r, state as a } from "lit/decorators.js";
import { logWarning as l } from "../../utilities/utils.js";
var h, u, p, d, c, b, C, f, O, I, y, T, v, g, N, m;
class A extends o {
  constructor() {
    super(...arguments), h.set(this, !1), u.set(this, !1), p.set(this, !1), d.set(this, !1), c.set(this, !1), b.set(this, !1), C.set(this, !1), f.set(this, !1), O.set(this, !1), I.set(this, !1), y.set(this, !1), T.set(this, "m"), v.set(this, !1), g.set(this, !1), N.set(this, ""), m.set(this, !1), this.setIconAttributes = () => {
      if (this.iconComponent && !this.fab) {
        this.iconComponent.isDisabled = this.disabled;
        let t = "var(--IDS-BUTTON__ICON-COLOR)",
          e = "var(--IDS-BUTTON__ICON-COLOR-2)";
        this.secondary ? this.active ? (t = "var(--IDS-BUTTON--SECONDARY-ACTIVE__ICON-COLOR)", e = "var(--IDS-BUTTON--SECONDARY-ACTIVE__ICON-COLOR-2)") : (t = "var(--IDS-BUTTON--SECONDARY__ICON-COLOR)", e = "var(--IDS-BUTTON--SECONDARY__ICON-COLOR-2)") : this.tertiary && (t = "var(--IDS-BUTTON--TERTIARY__ICON-COLOR)", e = "var(--IDS-BUTTON--TERTIARY__ICON-COLOR-2)"), this.setIconColors(t, e);
      }
    }, this.setIconHoveredAttributes = () => {
      if (this.iconComponent && !this.fab) {
        let t = "var(--IDS-BUTTON--ACTIVE__ICON-COLOR)",
          e = "var(--IDS-BUTTON--ACTIVE__ICON-COLOR-2)";
        this.secondary ? (t = "var(--IDS-BUTTON--SECONDARY-ACTIVE__ICON-COLOR)", e = "var(--IDS-BUTTON--SECONDARY-ACTIVE__ICON-COLOR-2)") : this.tertiary && (t = "var(--IDS-BUTTON--TERTIARY-ACTIVE__ICON-COLOR)", e = "var(--IDS-BUTTON--TERTIARY-ACTIVE__ICON-COLOR-2)"), this.setIconColors(t, e);
      }
    };
  }
  get active() {
    return e(this, h, "f");
  }
  set active(t) {
    s(this, h, t, "f");
  }
  get block() {
    return e(this, u, "f");
  }
  set block(t) {
    s(this, u, t, "f");
  }
  get disabled() {
    return e(this, p, "f");
  }
  set disabled(t) {
    s(this, p, t, "f");
  }
  get fab() {
    return e(this, d, "f");
  }
  set fab(t) {
    s(this, d, t, "f");
  }
  get icon() {
    return e(this, c, "f");
  }
  set icon(t) {
    s(this, c, t, "f");
  }
  get mblock() {
    return e(this, b, "f");
  }
  set mblock(t) {
    s(this, b, t, "f");
  }
  get sblock() {
    return e(this, C, "f");
  }
  set sblock(t) {
    s(this, C, t, "f");
  }
  get loading() {
    return e(this, f, "f");
  }
  set loading(t) {
    s(this, f, t, "f");
  }
  get tertiary() {
    return e(this, O, "f");
  }
  set tertiary(t) {
    s(this, O, t, "f");
  }
  get search() {
    return e(this, I, "f");
  }
  set search(t) {
    s(this, I, t, "f");
  }
  get secondary() {
    return e(this, y, "f");
  }
  set secondary(t) {
    s(this, y, t, "f");
  }
  get size() {
    return e(this, T, "f");
  }
  set size(t) {
    s(this, T, t, "f");
  }
  get submit() {
    return e(this, v, "f");
  }
  set submit(t) {
    s(this, v, t, "f");
  }
  get toggle() {
    return e(this, g, "f");
  }
  set toggle(t) {
    s(this, g, t, "f");
  }
  get type() {
    return e(this, N, "f");
  }
  set type(t) {
    s(this, N, t, "f");
  }
  get isHovered() {
    return e(this, m, "f");
  }
  set isHovered(t) {
    s(this, m, t, "f");
  }
  get iconComponent() {
    return this.querySelector(".ids-icon");
  }
  get button() {
    return this.querySelector("button") || this.querySelector("*");
  }
  get isButton() {
    return "BUTTON" === this.button?.tagName;
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.button ? (this.button.addEventListener("focus", this.setFocusTrue.bind(this)), this.button.addEventListener("blur", this.setFocusFalse.bind(this)), this.button.addEventListener("mouseenter", this.onMouseEnter.bind(this)), this.button.addEventListener("mouseleave", this.onMouseLeave.bind(this)), this.setupIcon(), this.updateButtonClasses()) : l(this, "No button element found in light dom.");
  }
  setupIcon() {
    this.iconComponent && (this.iconComponent.getAttribute("size") || this.iconComponent.setAttribute("size", "s"), this.fab || this.setIconAttributes());
  }
  updated(t) {
    super.updated(t), this.isButton && (this.disabled || this.loading ? (this.button.setAttribute("aria-disabled", "true"), this.button.setAttribute("tabindex", "-1")) : (this.button.removeAttribute("aria-disabled"), this.button.removeAttribute("tabindex")), this.toggle && this.button.setAttribute("aria-pressed", "" + this.active)), this.updateButtonClasses();
  }
  setIconColors(t, e) {
    this.iconComponent.setAttribute("color", t), this.iconComponent.setAttribute("color2", e);
  }
  onMouseEnter() {
    this.loading || (this.isHovered = !0, this.setIconHoveredAttributes());
  }
  onMouseLeave() {
    this.isHovered = !1, this.active || this.setIconAttributes();
  }
  setFocusTrue() {
    this.active = !0, this.setIconHoveredAttributes();
  }
  setFocusFalse() {
    this.active = !1, this.setIconAttributes();
  }
  updateClass(t) {
    this[t] ? this.button.classList.add(`ids-button--${t}`) : this.button.classList.remove(`ids-button--${t}`);
  }
  updateButtonClasses() {
    this.button.classList.add("ids-button"), "m" !== this.size && this.button.classList.add(`ids-button--${this.size}`), this.mblock && this.button.classList.add("ids-button--m-block"), this.sblock && this.button.classList.add("ids-button--s-block"), this.updateClass("active"), this.updateClass("fab"), this.updateClass("icon"), this.updateClass("secondary"), this.updateClass("tertiary"), this.updateClass("disabled"), this.updateClass("block"), this.updateClass("search"), this.updateClass("submit"), this.updateClass("loading");
  }
  render() {
    return n`<slot></slot>`;
  }
}
h = new WeakMap(), u = new WeakMap(), p = new WeakMap(), d = new WeakMap(), c = new WeakMap(), b = new WeakMap(), C = new WeakMap(), f = new WeakMap(), O = new WeakMap(), I = new WeakMap(), y = new WeakMap(), T = new WeakMap(), v = new WeakMap(), g = new WeakMap(), N = new WeakMap(), m = new WeakMap(), A.styles = [i`:host{display:contents}`], t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "active", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "block", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "disabled", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "fab", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "icon", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "mblock", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "sblock", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "loading", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "tertiary", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "search", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "secondary", null), t([r({
  type: String,
  reflect: !0
})], A.prototype, "size", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "submit", null), t([r({
  type: Boolean,
  reflect: !0
})], A.prototype, "toggle", null), t([r({
  type: String,
  reflect: !0
})], A.prototype, "type", null), t([a()], A.prototype, "isHovered", null);
export { A as IDSButton };